module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm-8 7c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm12 0c0-1.105.895-2 2-2s2 .895 2 2-.895 2-2 2-2-.895-2-2zm2.69 10h2.028c.29 2.266-1.014 4.517-3.25 5.33-2.59.943-5.465-.397-6.408-2.988-.566-1.555-2.29-2.36-3.845-1.793-1.424.517-2.217 2.008-1.906 3.45H7.28c-.29-2.266 1.014-4.517 3.25-5.33 2.59-.943 5.465.397 6.408 2.988.566 1.555 2.29 2.36 3.845 1.793 1.424-.517 2.217-2.008 1.906-3.45z\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./icons/confused.svg
 ** module id = 4
 ** module chunks = 0
 **/